import React, { useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import CustomAutoComplete from "../../../../components/formik/CustomAutoComplete";

const FormCrane = ({
  formik,
  craneTypes,
  insurers,
  findPermissionTypesByCoincidence,
  findAutotransportConfigByCoincidence,
}) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    setFieldValue,
    setFieldTouched,
  } = formik;

  return (
    <>
      <Row className="mb-3">
        <Form.Group as={Col} md="6">
          <Form.Label>Categoría(s) de grúa</Form.Label>
          <Select
            placeholder="Seleccione una o más categorías"
            options={craneTypes}
            isMulti
            value={craneTypes.filter((opt) =>
              values.crane_type_id?.some(
                (selected) => selected.value === opt.value
              )
            )}
            onChange={(selectedOptions) => {
              setFieldValue("crane_type_id", selectedOptions || []);
            }}
            className={errors.crane_type_id ? "is-invalid" : ""}
          />
          {errors.crane_type_id && (
            <div className="invalid-feedback d-block">
              {errors.crane_type_id}
            </div>
          )}
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="vehicular_config">
          <CustomAutoComplete
            formik={formik}
            field="vehicular_config"
            label="Configuración vehicular"
            searchFunction={findAutotransportConfigByCoincidence}
            descriptionField="descripcion"
          />
          {errors.vehicular_config && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.vehicular_config}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="sct_permit">
          <CustomAutoComplete
            formik={formik}
            field="sct_permit"
            label="Permiso SCT"
            searchFunction={findPermissionTypesByCoincidence}
            descriptionField="descripcion"
          />
          {errors.sct_permit && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.sct_permit}
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <Form.Group as={Col} md="6">
          <Form.Label>Número de permiso SCT</Form.Label>
          <Form.Control
            name="sct_permit_number"
            value={values.sct_permit_number}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("sct_permit_number", true, true);
            }}
            isInvalid={touched.sct_permit_number && !!errors.sct_permit_number}
          />
          <Form.Control.Feedback type="invalid">
            {errors.sct_permit_number}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="6">
          <Form.Label>Número de Grúa</Form.Label>
          <Form.Control
            name="crane_number"
            value={values.crane_number}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("crane_number", true, true);
            }}
            isInvalid={touched.crane_number && !!errors.crane_number}
          />
          <Form.Control.Feedback type="invalid">
            {errors.crane_number}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="6">
          <Form.Label>Placas</Form.Label>
          <Form.Control
            name="plate"
            value={values.plate}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("plate", true, true);
            }}
            isInvalid={touched.plate && !!errors.plate}
          />
          <Form.Control.Feedback type="invalid">
            {errors.plate}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="6">
          <Form.Label>Descripción</Form.Label>
          <Form.Control
            name="description"
            value={values.description}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("description", true, true);
            }}
            isInvalid={touched.description && !!errors.description}
          />
          <Form.Control.Feedback type="invalid">
            {errors.description}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="3">
          <Form.Label>Año</Form.Label>
          <Form.Control
            name="year"
            value={values.year}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("year", true, true);
            }}
            isInvalid={touched.year && !!errors.year}
          />
          <Form.Control.Feedback type="invalid">
            {errors.year}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="3">
          <Form.Label>Capacidad</Form.Label>
          <Form.Control
            name="capacity"
            value={values.capacity}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("capacity", true, true);
            }}
            isInvalid={touched.capacity && !!errors.capacity}
          />
          <Form.Control.Feedback type="invalid">
            {errors.capacity}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="6">
          <Form.Label>No. Serie</Form.Label>
          <Form.Control
            name="serial_number"
            value={values.serial_number}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("serial_number", true, true);
            }}
            isInvalid={touched.serial_number && !!errors.serial_number}
          />
          <Form.Control.Feedback type="invalid">
            {errors.serial_number}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="6">
          <Form.Label>Peso bruto vehicular</Form.Label>
          <Form.Control
            name="gross_vehicle_weight"
            value={values.gross_vehicle_weight}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("gross_vehicle_weight", true, true);
            }}
            isInvalid={
              touched.gross_vehicle_weight && !!errors.gross_vehicle_weight
            }
          />
          <Form.Control.Feedback type="invalid">
            {errors.gross_vehicle_weight}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="6">
          <Form.Label>Aseguradora</Form.Label>
          <Select
            placeholder="Seleccione aseguradora"
            options={insurers}
            value={
              insurers.find((opt) => opt.value === values.insurance_id) || null
            }
            onChange={(e) => {
              setFieldValue("insurance_id", e?.value || "");
            }}
            className={errors.insurance_id ? "is-invalid" : ""}
          />
          {errors.insurance_id && (
            <div className="invalid-feedback d-block">
              {errors.insurance_id}
            </div>
          )}
        </Form.Group>

        <Form.Group as={Col} md="6">
          <Form.Label>Póliza Responsabilidad Civil</Form.Label>
          <Form.Control
            name="civil_liability_policy"
            value={values.civil_liability_policy}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("civil_liability_policy", true, true);
            }}
            isInvalid={
              touched.civil_liability_policy && !!errors.civil_liability_policy
            }
          />
          <Form.Control.Feedback type="invalid">
            {errors.civil_liability_policy}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

export default FormCrane;
